import api from "./api";

export const getCreateUserProfileUrl = payload => {
  return {
    url: "/api/v1/profiles",
    config: payload,
  };
};
export const getSignupUserUrl = userData => {
  return {
    url: "/v2/users",
    config: userData,
  };
};

export const getUpdateUserProfileUrl = payload => {
  return {
    url: "/api/v1/profiles",
    config: payload,
  };
};

export const getUpdateUserUrl = payload => {
  return {
    url: "/api/v1/users",
    config: payload,
  };
};

export const loadUser = uid => {
  return api.get(`/api/v1/users/${uid}`);
};

export const getLoadUserByIdUrl = userId => {
  return {
    url: `/api/v1/users/${userId}`,
  };
};

export const getLoadUserByUsernameUrl = username => {
  return {
    url: `/api/v1/users/username/${username}`,
  };
};

export const getFetchUserProfileUrl = uid => {
  return { url: `/api/v1/profiles/${uid}` };
};

export const getFollowUserReq = followeeId => {
  return {
    url: "/api/v1/users/followers",
    config: { followeeId },
  };
};

export const getUnfollowUserReq = uid => {
  return {
    url: `/api/v1/users/followers/${uid}`,
  };
};

export const getLoadUserFollowersUrl = ({ userId, limit, pagingToken }) => {
  const params = { limit };
  if (pagingToken) {
    params.paging_token = pagingToken;
  }
  return {
    url: `/api/v1/users/${userId}/followers`,
    config: { params },
  };
};

export const getLoadUserFollowingUrl = ({ userId, limit, pagingToken }) => {
  const params = { limit };
  if (pagingToken) {
    params.paging_token = pagingToken;
  }
  return {
    url: `/api/v1/users/${userId}/following`,
    config: { params },
  };
};

export const getLoadUserCollectionsUrl = ({ userId, limit, pagingToken, postId }) => {
  const params = { limit };
  if (pagingToken) {
    params.paging_token = pagingToken;
  }
  if (postId) {
    params.post_id = postId;
  }
  return {
    url: `/api/v1/users/${userId}/collections`,
    config: { params },
  };
};

export const getLoadPreferencesUrl = () => {
  return {
    url: `/api/v1/users/preferences`,
  };
};
export const getUpdatePreferencesUrl = data => {
  return {
    url: `/api/v1/users/preferences`,
    config: data,
  };
};

export default {
  loadUser,
  getLoadUserByIdUrl,
  getSignupUserUrl,
  getLoadUserByUsernameUrl,
  getFetchUserProfileUrl,
  getCreateUserProfileUrl,
  getUpdateUserProfileUrl,
  getUpdateUserUrl,
  getFollowUserReq,
  getUnfollowUserReq,
  getLoadUserFollowersUrl,
  getLoadUserFollowingUrl,
  getLoadUserCollectionsUrl,
};



// WEBPACK FOOTER //
// ./src/api/UserApi.js